var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    viewBox: "0 0 30 30",
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.621094 7.792969 L 22.136719 7.792969 L 22.136719 21.582031 L 7.621094 21.582031 Z M 7.621094 7.792969"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4BBEF2",
    d: "M 15.53125 7.796875 C 12.949219 7.796875 10.628906 9.355469 9.546875 11.78125 L 7.636719 11.332031 L 9.671875 14.6875 L 12.890625 12.566406 L 11.03125 12.128906 C 11.921875 10.417969 13.636719 9.335938 15.535156 9.335938 C 18.359375 9.335938 20.660156 11.738281 20.660156 14.6875 C 20.660156 17.636719 18.359375 20.035156 15.53125 20.035156 C 15.125 20.035156 14.792969 20.382812 14.792969 20.808594 C 14.792969 21.230469 15.125 21.578125 15.53125 21.578125 C 19.175781 21.578125 22.140625 18.484375 22.140625 14.6875 C 22.140625 10.886719 19.175781 7.796875 15.53125 7.796875 Z M 15.53125 7.796875"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4BBEF2",
    d: "M 15.53125 9.75 C 15.125 9.75 14.792969 10.09375 14.792969 10.519531 L 14.792969 14.816406 C 14.792969 15.242188 15.125 15.585938 15.53125 15.585938 L 18.101562 15.585938 C 18.511719 15.585938 18.839844 15.242188 18.839844 14.816406 C 18.839844 14.390625 18.511719 14.046875 18.101562 14.046875 L 16.273438 14.046875 L 16.273438 10.519531 C 16.273438 10.09375 15.941406 9.75 15.53125 9.75 Z M 15.53125 9.75"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.935903f444710e31c40db483abb0552c.svg";
export { ForwardRef as ReactComponent };